// @flow

import CityModel from 'models/City';
import StateModel from 'models/State';

export default class NeighborhoodZip {
  id: string;
  name: string;
  location: Object;
  isPrincipal: boolean;
  enabled: boolean;
  city: CityModel;
  state: StateModel;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.location = data.location;
    this.isPrincipal = data.is_principal;
    this.enabled = data.enabled;
    this.city = new CityModel(data.city);
    this.state = new StateModel(data.city.state);
  }
}
